module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    attrs: {
      "id": "dim-panel"
    }
  }, [_c('app-header'), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7be0721c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyPanel/MyPanel.vue
// module id = 1693
// module chunks = 2